const ICON_CLOSE =
  '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" aria-hidden="true"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m15.625 4.375-11.25 11.25M15.625 15.625 4.375 4.375"/></svg>'

const ICON_CHEVRON_DOWN =
  '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" aria-hidden="true"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m14 8-4 4-4-4"/></svg>'

function ActiveFacet (params) {
  if (!params) {
    return ''
  }

  const props = {
    field: params.field || '',
    values: params.value || [],
    range: params.range || null,
  }

  return props.values
    .map((value) => {
      const label = props.field === 'price' ? renderPriceValue(value) : value

      return `
        <facet-remove
          class="drw-ProductGridFacets_ActiveFacet"
          data-results-filters-el="activeFacet"
          data-filter-label="${props.field}"
          data-filter-value="${value}"
          data-context="nosto"
        >
          <button
            class="drw-ProductGridFacets_ActiveLink fz-12_100"
            data-facet-remove-el="link"
          >
            ${label}
            ${ICON_CLOSE}
          </button>
        </facet-remove>
      `
    })
    .join('')
}

function renderPriceValue (rawValue) {
  const parts = rawValue.split('~')

  if (parts.length === 2) {
    const min = parseFloat(parts[0])
    const max = parseFloat(parts[1])

    const format = window.theme.shop.moneyFormat.replace(
      'amount',
      'amount_no_decimals',
    )

    const minFormatted = window.BAO.Utils.formatMoney(min * 100, format)
    const maxFormatted = window.BAO.Utils.formatMoney(max * 100, format)

    return `${minFormatted} - ${maxFormatted}`
  }

  return rawValue
}

function FauxFacet (params, index) {
  if (!params) {
    return ''
  }

  const props = {
    index: index || 0,
    name: params.name || '',
    field: params.field || '',
  }

  let propName = props.name
  const propNameHandle = propName.toLowerCase().replaceAll(' ', '')

  if (window.theme.strings.sections.collectionTemplate.facets[propNameHandle]) {
    propName =
      window.theme.strings.sections.collectionTemplate.facets[propNameHandle]
  }

  return `
      <div class="clc-ProductGrid_Facet clc-ProductGrid_Facet-accordion">
        <button
          class="clc-ProductGrid_FacetsTrigger fz-13_100"
          type="button"
          data-drawers-trigger="results-filters"
          data-results-filters-el="fauxFacetTrigger"
          data-accordion="facet-${props.field}"
        >
          ${propName}

          <span class="drw-ProductGridFacets_TriggerIcon">
            ${ICON_CHEVRON_DOWN}
          </span>
        </button>
      </div>
    `
}

window.templates.ActiveFacet = ActiveFacet
window.templates.FauxFacet = FauxFacet
